import { render, staticRenderFns } from "./BudgetEdit.vue?vue&type=template&id=521a278e"
import script from "./BudgetEdit.vue?vue&type=script&lang=js"
export * from "./BudgetEdit.vue?vue&type=script&lang=js"
import style0 from "./BudgetEdit.vue?vue&type=style&index=0&id=521a278e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports